"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntereactionLayer = void 0;
const pixi_js_1 = require("pixi.js");
const Constants_1 = require("../../Core/Constants");
const GameConfig_1 = require("../../Core/GameConfig");
const inversify_1 = require("inversify");
const GameState_1 = require("../../Core/GameState");
let IntereactionLayer = class IntereactionLayer extends pixi_js_1.Container {
    constructor(config, state) {
        super();
        const hw = 4.5 * Constants_1.LaneWidth;
        const h = Constants_1.LayerHeight * 1.2;
        const rect = new pixi_js_1.Graphics();
        rect.position.set(Constants_1.CenterX, Constants_1.LayerHeight * 0.3);
        rect.lineStyle(3, 0xff0088);
        rect.moveTo(-hw, 0).lineTo(hw, 0).lineTo(hw, h).lineTo(-hw, h).lineTo(-hw, 0);
        this.addChild(rect);
        rect.alpha = config.debug ? 1 : 0;
        rect.interactive = true;
        //        rect.buttonMode = true
        rect.hitArea = rect.getLocalBounds();
        const getlane = (x, y) => {
            if (y < 0)
                return -1;
            const pm = x >= 0 ? 1 : -1;
            let dl = (Math.abs(x) + Constants_1.LaneWidth / 2) / Constants_1.LaneWidth;
            if (dl >= 5)
                return -1;
            if (dl >= 4)
                dl = 3.5;
            return 3 + Math.floor(dl) * pm;
        };
        const typemap = {
            pointerup: "up",
            pointerdown: "down",
            pointerupoutside: "up",
            pointermove: "move",
        };
        const listen = (...events) => {
            events.forEach(name => rect.on(name, (e) => {
                e.stopPropagation();
                const type = typemap[name];
                const p = rect.toLocal(e.data.global);
                const pointerId = e.data.pointerId || 0xffffff;
                const ev = {
                    pointerId,
                    time: 0,
                    lane: getlane(p.x, p.y),
                    type,
                    x: p.x,
                    y: p.y,
                };
                state.on.pointer.emit(ev);
                if (config.debug && name.indexOf("move") < 0)
                    console.log(name, ev);
            }));
        };
        listen("pointerup", "pointerdown", "pointerupoutside", "pointermove");
    }
};
IntereactionLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameConfig_1.GameConfig, GameState_1.GameState])
], IntereactionLayer);
exports.IntereactionLayer = IntereactionLayer;
//# sourceMappingURL=IntereactionLayer.js.map